import * as $                        from 'jquery';
import { onClick, onLoad }           from 'Core/Events';
import { commonShowTarget }          from './CommonFunctions';

export const Sidenav = (() => {

    const Selector = {
        CATEGORY_ITEM:                     '.sidenav-list-item',
        CATEGORY_ARROW:                    '.arrow-cat-toggler',
        SIDENAV:                           '#sidenav',
        CURRENT_SUBCATEGORY:               '.current-subcat',
        SIDENAV_MOBILE_BTN:                '#js_sidenav_mobile'
    }

    onLoad(showCurrentCategoryExpanded);
    onClick(Selector.CATEGORY_ARROW, toggleCategoryHandler);
    onClick(Selector.SIDENAV_MOBILE_BTN, () => commonShowTarget(Selector.SIDENAV)) //for mobile version - show/hide categories component. Basicly, component is not visible.


    function showCurrentCategoryExpanded() { //open current, chosen category/subcategory 
        const currentSubcategoryParent = $(Selector.CURRENT_SUBCATEGORY).parent();
        const prevParent = currentSubcategoryParent.prev();
        currentSubcategoryParent.addClass('show');
        elementOpen(prevParent.find('.arrow-cat-toggler'));
    }

    function toggleCategoryHandler() { //handler for category - arrows and show list of subcategories
        arrowChangeHandler(this);
        toggleCategoryExpanding(this);
    }


    function arrowChangeHandler(target) { 
        target = $(target).closest('.arrow-cat-toggler');
        if (
            $(target)
                .prev()
                .attr('aria-expanded') == 'true'
        ) {
            elementClose($(target));
        } else {
            closeAllArrows();
            elementOpen($(target));
        }
    }


    function collapseOther() {  //used on category expanding handler before open current category
        $(Selector.SIDENAV).each(function (index, element) {
            $(element).find('[aria-expanded]').attr('aria-expanded', 'false');
            $(element).find('.collapse.show').collapse('hide');
        })
    }

    function closeAllArrows() {  //close all arrows. used on arrow handler before open clicked
        $(Selector.SIDENAV).each(function (index, element) {
            elementClose($(element).find(Selector.CATEGORY_ARROW));
        })
    }

    function toggleCategoryExpanding(target) { //handler for expanding category. Used on click per arrow
        if (
            $(target)
                .prev()
                .attr('aria-expanded') == 'true'
        ) {
            $(target)
                .prev()
                .attr('aria-expanded', 'false');
            $(target)
                .parent()
                .next()
                .collapse('hide');
        } else {
            collapseOther();
            $(target)
                .prev()
                .attr('aria-expanded', 'true');
            $(target)
                .parent()
                .next()
                .collapse('show');
        }
    }

    function elementClose(element) { //handler for close arrow
        $(element)
            .removeClass('fa-chevron-up text-primary')
            .addClass('fa-chevron-down');
    }
    
    function elementOpen(element) { //handler for open arrow
        $(element)
            .removeClass('fa-chevron-down')
            .addClass('fa-chevron-up text-primary');
    }

})();
import * as $                        from 'jquery';
import { onClick, onLoad }           from 'Core/Events';
import { commonShowTarget }          from './CommonFunctions';

export const Sidenav = (() => {

    const Selector = {
        CATEGORY_ITEM:                     '.sidenav-list-item',
        CATEGORY_ARROW:                    '.arrow-cat-toggler',
        SIDENAV:                           '#sidenav',
        CURRENT_SUBCATEGORY:               '.current-subcat',
        SIDENAV_MOBILE_BTN:                '#js_sidenav_mobile'
    }

    onLoad(showCurrentCategoryExpanded);
    onClick(Selector.CATEGORY_ARROW, toggleCategoryHandler);
    onClick(Selector.SIDENAV_MOBILE_BTN, () => commonShowTarget(Selector.SIDENAV)) //for mobile version - show/hide categories component. Basicly, component is not visible.


    function showCurrentCategoryExpanded() { //open current, chosen category/subcategory 
        const currentSubcategoryParent = $(Selector.CURRENT_SUBCATEGORY).parent();
        const prevParent = currentSubcategoryParent.prev();
        currentSubcategoryParent.addClass('show');
        elementOpen(prevParent.find('.arrow-cat-toggler'));
    }

    function toggleCategoryHandler() { //handler for category - arrows and show list of subcategories
        arrowChangeHandler(this);
        toggleCategoryExpanding(this);
    }


    function arrowChangeHandler(target) { 
        target = $(target).closest('.arrow-cat-toggler');
        if (
            $(target)
                .prev()
                .attr('aria-expanded') == 'true'
        ) {
            elementClose($(target));
        } else {
            closeAllArrows();
            elementOpen($(target));
        }
    }


    function collapseOther() {  //used on category expanding handler before open current category
        $(Selector.SIDENAV).each(function (index, element) {
            $(element).find('[aria-expanded]').attr('aria-expanded', 'false');
            $(element).find('.collapse.show').collapse('hide');
        })
    }

    function closeAllArrows() {  //close all arrows. used on arrow handler before open clicked
        $(Selector.SIDENAV).each(function (index, element) {
            elementClose($(element).find(Selector.CATEGORY_ARROW));
        })
    }

    function toggleCategoryExpanding(target) { //handler for expanding category. Used on click per arrow
        if (
            $(target)
                .prev()
                .attr('aria-expanded') == 'true'
        ) {
            $(target)
                .prev()
                .attr('aria-expanded', 'false');
            $(target)
                .parent()
                .next()
                .collapse('hide');
        } else {
            collapseOther();
            $(target)
                .prev()
                .attr('aria-expanded', 'true');
            $(target)
                .parent()
                .next()
                .collapse('show');
        }
    }

    function elementClose(element) { //handler for close arrow
        $(element)
            .removeClass('fa-chevron-up text-primary')
            .addClass('fa-chevron-down');
    }
    
    function elementOpen(element) { //handler for open arrow
        $(element)
            .removeClass('fa-chevron-down')
            .addClass('fa-chevron-up text-primary');
    }

})();
